var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2770_16271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2770_16271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 13.6886L4.023 20.6655C3.92942 20.7591 3.81788 20.8027 3.68838 20.7963C3.5589 20.7899 3.44736 20.7399 3.35378 20.6463C3.26018 20.5527 3.21338 20.4369 3.21338 20.2988C3.21338 20.1608 3.26018 20.0471 3.35378 19.9578L10.3115 13.0001H5.49993C5.35826 13.0001 5.23951 12.9521 5.14368 12.8562C5.04785 12.7602 4.99993 12.6413 4.99993 12.4994C4.99993 12.3576 5.04785 12.2389 5.14368 12.1434C5.23951 12.0479 5.35826 12.0001 5.49993 12.0001H11.1922C11.4211 12.0001 11.6129 12.0775 11.7677 12.2323C11.9225 12.3871 11.9999 12.579 11.9999 12.8078V18.5001C11.9999 18.6418 11.9519 18.7605 11.856 18.8564C11.76 18.9522 11.6411 19.0001 11.4993 19.0001C11.3574 19.0001 11.2387 18.9522 11.1432 18.8564C11.0477 18.7605 10.9999 18.6418 10.9999 18.5001V13.6886ZM13.6884 11.0001H18.4999C18.6416 11.0001 18.7603 11.0481 18.8562 11.1441C18.952 11.24 18.9999 11.3589 18.9999 11.5008C18.9999 11.6426 18.952 11.7613 18.8562 11.8568C18.7603 11.9524 18.6416 12.0001 18.4999 12.0001H12.8076C12.5788 12.0001 12.3869 11.9227 12.2321 11.7679C12.0773 11.6131 11.9999 11.4213 11.9999 11.1924V5.50011C11.9999 5.35844 12.0479 5.23969 12.1439 5.14386C12.2398 5.04803 12.3588 5.00011 12.5006 5.00011C12.6425 5.00011 12.7612 5.04803 12.8567 5.14386C12.9522 5.23969 12.9999 5.35844 12.9999 5.50011V10.3116L19.9769 3.33471C20.0662 3.24113 20.1798 3.19434 20.3179 3.19434C20.4559 3.19434 20.5717 3.24113 20.6653 3.33471C20.7589 3.42831 20.8057 3.54413 20.8057 3.68216C20.8057 3.82019 20.7589 3.93387 20.6653 4.02319L13.6884 11.0001Z",
    fill: "#777777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatClose);
export default __webpack_public_path__ + "static/media/Icon_chat_close.770b34efe6563e3fccd21c6cfa3bf58d.svg";
export { ForwardRef as ReactComponent };